/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TradeOnboardingCoachmarkConditionalLoader_item$ref: FragmentReference;
export type TradeOnboardingCoachmarkConditionalLoader_item = {|
  +serviceId: ?string,
  +$refType: TradeOnboardingCoachmarkConditionalLoader_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TradeOnboardingCoachmarkConditionalLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b85597d13658b133a50c92954559b8e0';
module.exports = node;
